import ApiClient from './apiClient';

export interface ExportClientsFilterPayload {
  programTagIds?: string[];
  excludedProgramTagIds?: string[];
  assignedProviderUserIds?: string[];
  excludedAssignedProviderUserIds?: string[];
  tagsMatch?: 'ALL' | 'ANY';
  assignedProviderUsersMatch?: 'ALL' | 'ANY';
  filterOperator?: 'AND' | 'OR';
}

export interface ExportClientsPayload {
  patientLifecycleStatuses?: string[];
  filter?: ExportClientsFilterPayload;
}

export const generateFilename = (): string => {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `clients-export_${timestamp}.zip`;
};

export const downloadFile = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const exportClients = async (
  payload?: ExportClientsPayload,
): Promise<Blob> => {
  // ApiClient.post signature is (url, config, data)
  return ApiClient.post<Blob>(
    '/patients-data-export',
    { responseType: 'blob' },
    payload ?? {},
  );
};
